import {
  Card,
  Container,
  CardHeader,
  Divider,
  Grid,
  CardContent,
  createMuiTheme,
  Select,
  Typography,
  FormControl,
  TextField,
  CardActions,
  Button,
  CircularProgress,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
  InputAdornment,
  DialogContent,
  DialogTitle,
  Dialog,
  DialogActions,
  Slide,
  LinearProgress,
  TableContainer,
  Checkbox,
  Backdrop,
  Slider,
  Input,
  Snackbar,
  TableSortLabel
} from '@material-ui/core';
import LockIcon from '@material-ui/icons/Lock';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import React, { useState } from 'react';
import Page from 'src/components/Page';
import { CustomTableCell } from 'src/components/CustomTableCell';
import axios from 'src/utils/axios';
import {
  getUser,
  sc,
  GetWarehouseAddress,
  getSepetAdet,
  setSepetAdet,
  CreateWareHouseAddress
} from 'src/utils/Common';
import DateFnsUtils from '@date-io/date-fns';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import trLocale from 'date-fns/locale/tr';
import moment from 'moment';
import SearchIcon from '@material-ui/icons/Search';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import CloseIcon from '@material-ui/icons/Close';
import GenericBulten from 'src/components/GenericBulletin';
import SendIcon from '@material-ui/icons/Send';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import AddressSearch from 'src/components/Selects/AddressSearch';
import CropFreeIcon from '@material-ui/icons/CropFree';
import clsx from 'clsx';
import BarcodeVoice from 'src/assets/sound/Bip.mp3';
import ErrorVoice from 'src/assets/sound/Error.mp3';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import MuiAlert from '@material-ui/lab/Alert';


function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  cardUstBolum: {
    maxHeight: 700,
    minHeight: 700,
    width: '100%'
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  container: {
    maxHeight: 497,
    minHeight: 497,
    mimWidth: 500
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}));
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    }
  }
});
const localeMap = {
  tr: trLocale
};


function TechnicianPlan() {
  const classes = useStyles();
  const today = moment(new Date()).format('YYYY-MM-DD');
  const [TeknisyenKodu, setTeknisyenKodu] = useState('');
  const [ZimmetAciklama, setZimmetAciklama] = useState('');
  const [TeknisyenData, setTeknisyenData] = useState([]);
  const [TeknisyenPlanData, setTeknisyenPlanData] = useState([]);
  const [baslangicTarihi, setBaslangicTarihi] = React.useState(today);
  const [bitisTarihi, setBitisTarihi] = React.useState(today);
  const [Loading, setLoading] = useState(false);
  const [WarehouseAddress, setWarehouseAddress] = useState([]);
  const [bultenOpen, setBultenOpen] = React.useState(false);
  const [bultenParam, setBultenParam] = React.useState('');
  const [LoadingMaterial, setLoadingMaterial] = React.useState(true);
  const [ImageUrl, setImageUrl] = useState(null);
  const [openMaterialFileTitle, setOpenMaterialFileTitle] = React.useState('');
  const [openMaterialFile, setOpenMaterialFile] = React.useState(false);
  const [previous, setPrevious] = React.useState({});
  const [selected, setSelected] = React.useState([]);
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const SessionUser = getUser();
  const [Barcode, setBarcode] = useState('');
  const likeAudio = new Audio(BarcodeVoice);
  const ErrorAudio = new Audio(ErrorVoice);
  const [SiparisAdetTitle, setSiparisAdetTitle] = React.useState('');
  const [openSiparisAdet, setopenSiparisAdet] = React.useState(false);
  const [MalzemeSiparis, setMalzemeSiparis] = React.useState('');
  const [siparisAdet, setsiparisAdet] = React.useState(1);
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('');
  const handleteknisyenChange = e => {
    setTeknisyenKodu(e.target.value);
    setTeknisyenPlanData([]);
  };

  const onChange = (e, row) => {
    if (!previous[row.MALZEME_STOK_NO]) {
      setPrevious(state => ({ ...state, [row.MALZEME_STOK_NO]: row }));
    }
    var value = e.target.value;
    const name = e.target.name;

    if (parseInt(value) < 0) {
      value = 1;
    }
    const newRows = TeknisyenPlanData.map(item => {
      if (
        item.MALZEME_STOK_NO === row.MALZEME_STOK_NO
      ) {
        return { ...item, [name]: value };
      }
      return item;
    });

    setTeknisyenPlanData(newRows);
  };

  React.useEffect(() => {
    CreateWareHouseAddress(SessionUser.ServiceShopId);
    axios
      .get(`/GetTechnicianDebit/${SessionUser.ServiceShopId}/${baslangicTarihi}/${bitisTarihi}`)
      .then(response => {
        if (response.data.length > 0) {
          setTeknisyenData(response.data);
        }
      })
      .catch(error => {
        console.log(error);
      });
    var DegerWarehouseAddress = [];
    DegerWarehouseAddress = GetWarehouseAddress(SessionUser.ServiceShopId);
    setWarehouseAddress(DegerWarehouseAddress);
  }, []);
  const handleDateChange = (event, type) => {
    var Deger = moment(event).format('YYYY-MM-DD');
    type === 1 ? setBaslangicTarihi(Deger) : setBitisTarihi(Deger);
  };
  function onSorgula() {
    if (TeknisyenKodu === '') {
      setUyariTip('error');
      setUyariAciklama("Teknisyen Seçiniz!...");
      setUyari(true);
      return;
    }
    setLoading(true);
    axios
      .get(
        `/GetTechnicianPlanMaterial/${SessionUser.ServiceShopId}/${TeknisyenKodu}`
      )
      .then(response => {
        setLoading(false);
        if (response.data.length > 0) {
          setTeknisyenPlanData(response.data);
        } else {
          setTeknisyenPlanData([]);
        }



      })
      .catch(error => {
        setLoading(false);
        console.log(error);
      });
  }
  const GetMaterialImage = (event, materialCode) => {
    setOpenMaterialFile(true);
    setLoadingMaterial(true);
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    setOpenMaterialFileTitle(materialCode + ' Numaralı Malzeme Detayı');
    axios
      .get(`MaterialFile/${materialCode}`, config)
      .then(response => {
        var fileURL = URL.createObjectURL(response.data);
        setImageUrl(fileURL);
        setLoadingMaterial(false);
      })
      .catch(error => {
        setLoadingMaterial(false);
      });
  };
  const GetMaterialBulletin = (event, materialCode) => {
    setBultenParam(materialCode);
    setBultenOpen(true);
    setLoadingMaterial(false);
  };
  const handleCloseMaterialFile = () => {
    setOpenMaterialFile(false);
  };
  const isSelected = name => selected.indexOf(name) !== -1;

  const handleClick = (event, row, index) => {
    if (row.RowSelected === 0) {
      row.RowSelected = 1;
    } else {
      row.RowSelected = 0;
    }
    let TeknisyenPlanDataOld = [...TeknisyenPlanData];
    setTeknisyenPlanData(TeknisyenPlanDataOld);
  };
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const CikisYapDetay = event => {
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };


    const data = TeknisyenPlanData.map(item => ({
      ServiceShopId: SessionUser.ServiceShopId,
      TechnicianId: TeknisyenKodu,
      Description: ZimmetAciklama,
      MinCount: item.MIN_ADET,
      MaxCount: item.MAX_ADET,
      MaterialCode: item.MALZEME_STOK_NO,
      UserId: SessionUser.OrganizationUserId
    }));

    if (data.length < 1) {
      setUyariTip('error');
      setUyariAciklama("Kaydedilecek veri bulunmuyor!...");
      setUyari(true);
      return;
    }


    axios
      .post('/SetTechnicianPlanSendtoCenter', data, config)
      .then(response => {
        setLoading(false);
        setUyariTip('success');
        onSorgula();
        let ResponseData = response.data[0];
        setUyariAciklama(ResponseData.ErrorDescription);
        setUyari(true);
      });
  };

  const CikisYap = event => {


    setZimmetAciklama('');

    confirmAlert({
      message: 'Değişiklikler kaydedilecektir. Devam etmek istediğinize eminmisiniz?...',
      buttons: [
        {
          label: 'Evet',
          onClick: () => CikisYapDetay(event)
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };
  const playSound = audioFile => {
    audioFile.play();
  };

  const SetBarcodeAddItemKabul = (Barcode, Data) => {
    setLoading(true);
    axios
      .get('GetMaterialDescription/' + Barcode)
      .then(response => {
        setLoading(false);
        let Deger = {
          MALZEME: response.data,
          MALZEME_KODU: 0,
          MALZEME_STOK_NO: Barcode,
          RowSelected: 0,
          MIN_ADET: 1,
          MAX_ADET: 1,
          MIN_ONERI: 0,
          MAX_ONERI: 0,
          HAFTALIK_ORTALAMA_SARF: 0,
          DORT_HAFTALIK_MALZEME_SARF: 0,
          DORT_HAFTALIK_FREKANS: 0
        };

        var VarMi = TeknisyenPlanData.filter(d => d.MALZEME_STOK_NO === Barcode);
        if (VarMi.length > 0) {
          var rowsParam = [...TeknisyenPlanData];
          var rowsParamIndex = TeknisyenPlanData.findIndex(d => d.MALZEME_STOK_NO === Barcode);
          rowsParam[rowsParamIndex].MAX_ADET = rowsParam[rowsParamIndex].MAX_ADET + 1;
          setTeknisyenPlanData(rowsParam);
        } else {
          let DegerOld = [Deger, ...TeknisyenPlanData];
          setTeknisyenPlanData(DegerOld);
        }

        setBarcode("");
      })
      .catch(error => {
        setLoading(false);
        console.log(error);
      });
  };

  const SetMaterialDelete = (event, row, MALZEME_STOK_NO) => {
    confirmAlert({
      message:
        'Planlanan malzeme silinecektir!... Devam etmek istediğinizden emin misiniz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => {
            SetMaterialDeleteKabul(event, row, MALZEME_STOK_NO);
          }
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  const SetMaterialDeleteKabul = (event, row, MALZEME_STOK_NO) => {
    setLoading(true);
    axios
      .get(`/SetMaterialTechnicianPlanDelete/${MALZEME_STOK_NO}/${SessionUser.ServiceShopId}/${TeknisyenKodu}/1`)
      .then(response => {
        setLoading(false);
        var TeknisyenPlanDataParam = [...TeknisyenPlanData];
        var filteredIndex = TeknisyenPlanDataParam.findIndex(
          x => x.MALZEME_STOK_NO === MALZEME_STOK_NO
        );
        TeknisyenPlanDataParam.splice(filteredIndex, 1);
        setTeknisyenPlanData(TeknisyenPlanDataParam);
      })
      .catch(error => {
        setLoading(false);
        console.log(error);
      });
  };

  const SetBarcodeAddItem = Barcode => {
    if (Barcode === '') {
      return;
    }
    playSound(ErrorAudio);
    var Varmi = TeknisyenPlanData.filter(
      d => d.MALZEME_STOK_NO === Barcode && d.FIS_NO === 'Fişsiz Malzeme'
    );
    if (Varmi.length > 0) {
      var rowsParam = [
        ...TeknisyenPlanData.map(item => ({
          ...item
        }))
      ];
      var rowsParamIndex = TeknisyenPlanData.findIndex(
        d => d.MALZEME_STOK_NO === Barcode && d.FIS_NO === 'Fişsiz Malzeme'
      );
      rowsParam[rowsParamIndex].Count =
        parseInt(rowsParam[rowsParamIndex].Count) + 1;
      setTeknisyenPlanData(rowsParam);
      return;
    }
    axios
      .get('GetMaterialDescription/' + Barcode)
      .then(response => {
        if (response.data === '') {
          setUyariTip('error');
          setUyariAciklama(Barcode + ' stok numaralı malzeme sistemde tanımlı degil!...');
          setUyari(true);
          return;
        }

        SetBarcodeAddItemKabul(Barcode, response.data);

      })
      .catch(error => {
        setUyariTip('error');
        setUyariAciklama('Bir hata oluştu lütfen tekrar deneyiniz!...');
        setUyari(true);
        return;
      });
  };

  const SepeteEkleDetay = event => {
    setLoading(true);
    const data = {
      MALZEME_STOK_NO: MalzemeSiparis,
      BIRIM_KODU: SessionUser.ServiceShopId,
      TEKNISYEN_KODU: SessionUser.OrganizationUserId,
      ADET: siparisAdet
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetMaterialBasket', data, config)
      .then(response => {
        if (response.data[0].ErrorCode === '0') {
          var Deger = getSepetAdet();
          setSepetAdet(parseInt(Deger) + 1);
          setUyariTip('success');
          setUyariAciklama('İşlem başarılı');
          setUyari(true);

        } else {
          setUyariTip('error');
          setUyariAciklama(response.data[0].ErrorDescription);
          setUyari(true);
        }
        setLoading(false);
        setopenSiparisAdet(false);
        setsiparisAdet(1);
      })
      .catch(error => {
        setUyariTip('error');
        setUyariAciklama('Bir hata oluştu!..' + error.message);
        setUyari(true);
        setLoading(false);
      });
  };

  const SepeteEkle = (event, MALZEME_STOK_NO) => {
    setMalzemeSiparis(MALZEME_STOK_NO);
    setSiparisAdetTitle(
      MALZEME_STOK_NO +
      ' numaralı malzeme sipariş verebilmeniz için sepete eklenecektir!... Devam etmek istediğinizden emin misiniz?'
    );
    setopenSiparisAdet(true);
  };
  const handleCloseSiparisAdet = () => {
    setopenSiparisAdet(false);
    setsiparisAdet(1);
  };
  const handleSliderChange = (event, newValue) => {
    setsiparisAdet(newValue);
    if (Number(newValue) < 0) {
      setsiparisAdet(0);
    } else if (Number(newValue) > 999) {
      setsiparisAdet(999);
    }
  };
  const handleInputChange = event => {
    setsiparisAdet(event.target.value === '' ? '' : Number(event.target.value));
    if (Number(event.target.value) < 0) {
      setsiparisAdet(0);
    } else if (Number(event.target.value) > 999) {
      setsiparisAdet(999);
    }
  };
  const handleBlur = () => {
    if (siparisAdet < 0) {
      setsiparisAdet(0);
    } else if (siparisAdet > 999) {
      setsiparisAdet(999);
    }
  };


  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort, Header } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };
    return (
      <TableHead>
        <TableRow>
          {Header.map((headCell) => (
            <TableCell
              key={headCell.id}
              align={'left'}
              padding={headCell.disablePadding ? 'none' : 'default'}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {''}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const headMalzemeZimmetCells = [
    { id: 'MALZEME_STOK_NO', numeric: true, disablePadding: true, label: 'MalzemeStokNo' },
    { id: 'MALZEME', numeric: true, disablePadding: true, label: 'Malzeme' },
    { id: 'MIN_ADET', numeric: true, disablePadding: true, label: 'MinAdet' },
    { id: 'MAX_ADET', numeric: true, disablePadding: true, label: 'MaxAdet' },
    { id: 'MIN_ONERI', numeric: true, disablePadding: true, label: 'MinÖneri' },
    { id: 'MAX_ONERI', numeric: true, disablePadding: true, label: 'MaxÖneri' },
    { id: 'HAFTALIK_ORTALAMA_SARF', numeric: true, disablePadding: true, label: 'HaftalıkOrtalamaSarf' },
    { id: 'DORT_HAFTALIK_MALZEME_SARF', numeric: true, disablePadding: true, label: 'DörtHaftalıkSarf' },
    { id: 'DORT_HAFTALIK_FREKANS', numeric: true, disablePadding: true, label: 'HaftalıkFrekans' },
    { id: 'FIS_NO', numeric: true, disablePadding: true, label: 'Resim' },
    { id: 'FIS_NO', numeric: true, disablePadding: true, label: 'Bülten' },
    { id: 'FIS_NO', numeric: true, disablePadding: true, label: 'Sil' },
    { id: 'FIS_NO', numeric: true, disablePadding: true, label: 'Sipariş' },

  ];

  return (
    <Page className={classes.root} title="oasis Yönetimi">
      <Container maxWidth="xl">
        <Card>
          <CardHeader title="Planlama - Teknisyen Zimmet Planlama" />
          <Divider />
          <Snackbar open={uyari} autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={uyariKapat}>
            <Alert onClose={uyariKapat} severity={uyariTip}>
              {uyariAciklama || ''}
            </Alert>
          </Snackbar>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={2}>
                <Card className={classes.cardUstBolum}>
                  <CardHeader title="Teknisyen İşlemleri" />
                  <Backdrop className={classes.backdrop} open={Loading}>
                    <CircularProgress color="inherit" />
                  </Backdrop>
                  <Divider />
                  <CardContent>
                    <FormControl variant="outlined" className={classes.fields}>
                      <Typography
                        className={classes.title}
                        color="textSecondary"
                        gutterBottom
                      >
                        Teknisyen
                      </Typography>
                      <Typography variant="h6" component="h2">
                        <Select
                          native
                          value={TeknisyenKodu}
                          onChange={handleteknisyenChange}
                          fullWidth
                          labelId="teknisyen_label"
                          inputProps={{
                            name: 'teknisyen_select',
                            id: 'teknisyen_select'
                          }}
                        >
                          <option value="" defaultValue>
                            {TeknisyenKodu}
                          </option>
                          {TeknisyenData.map(p => {
                            return (
                              <option
                                key={p.TEKNISYEN_KODU}
                                value={p.TEKNISYEN_KODU}
                              >
                                {p.KUL_TEK_KODU + '-' + p.ACIKLAMA}
                              </option>
                            );
                          })}
                        </Select>
                      </Typography>
                    </FormControl>
                  </CardContent>
                  <Divider />
                  <CardActions className={classes.actionsKesifSms}>
                    <Button
                      variant="contained"
                      color="secondary"
                      fullWidth
                      endIcon={<SearchIcon>Sorgula</SearchIcon>}
                      onClick={onSorgula}
                    >
                      Sorgula
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
              <Grid item xs={12} sm={10}>
                <Card className={classes.cardUstBolum}>
                  <CardHeader
                    title="İşlemler"
                    action={
                      <Button
                        variant="contained"
                        className={classes.button}
                        color="secondary"
                        endIcon={<SendIcon></SendIcon>}
                        onClick={event => CikisYap(event)}
                      >
                        Kaydet
                      </Button>
                    }
                  />
                  <Divider />
                  <CardActions>
                    <FormControl fullWidth className={classes.margin}>
                      <TextField
                        label="Barkod"
                        value={Barcode}
                        name={Barcode}
                        className={clsx(classes.margin, classes.textField)}
                        onChange={event => {
                          setBarcode(event.target.value);
                        }}
                        onKeyPress={event => {
                          if (event.key === 'Enter') {
                            SetBarcodeAddItem(event.target.value);
                          }
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <CropFreeIcon />
                            </InputAdornment>
                          )
                        }}
                      />
                    </FormControl>
                  </CardActions>
                  <Divider />
                  <CardContent>
                    <TableContainer className={classes.container}>
                      <Table
                        size="small"
                        stickyHeader>
                        <EnhancedTableHead
                          classes={classes}
                          order={order}
                          orderBy={orderBy}
                          onRequestSort={handleRequestSort}
                          Header={headMalzemeZimmetCells}
                        />
                        <TableBody>
                          {stableSort(TeknisyenPlanData, getComparator(order, orderBy))
                            .map((row, index) => {
                              const isItemSelected = isSelected(index);
                              const labelId = `enhanced-table-checkbox-${index}`;
                              return (
                                <TableRow
                                  hover
                                  role="checkbox"
                                  aria-checked={isItemSelected}
                                  tabIndex={-1}
                                  key={index}
                                  selected={isItemSelected}
                                >
                                  <TableCell align="left" padding='none' className={classes.tableCell}>{row.MALZEME_STOK_NO}</TableCell>
                                  <TableCell
                                    align="left" padding='none'
                                    title={row.MALZEME}
                                    className={classes.tableCell}
                                  >
                                    {row.MALZEME}
                                  </TableCell>
                                  <CustomTableCell {...{ row, name: "MIN_ADET", onChange, Adet: row.MIN_ADET }} />
                                  <CustomTableCell {...{ row, name: "MAX_ADET", onChange, Adet: row.MAX_ADET }} />

                                  <TableCell align="center" padding='none' className={classes.tableCell}>{row.MIN_ONERI}</TableCell>
                                  <TableCell align="center" padding='none' className={classes.tableCell}>{row.MAX_ONERI}</TableCell>
                                  <TableCell align="center" padding='none' className={classes.tableCell}>{row.HAFTALIK_ORTALAMA_SARF}</TableCell>
                                  <TableCell align="center" padding='none' className={classes.tableCell}>{row.DORT_HAFTALIK_MALZEME_SARF}</TableCell>
                                  <TableCell align="center" padding='none' className={classes.tableCell}>{row.DORT_HAFTALIK_FREKANS}</TableCell>


                                  <TableCell
                                    align="left" padding='none'
                                    className={classes.tableCell}
                                  >
                                    <ImageSearchIcon
                                      onClick={event =>
                                        GetMaterialImage(
                                          event,
                                          row.MALZEME_STOK_NO
                                        )
                                      }
                                      color="primary"
                                    />
                                  </TableCell>
                                  <TableCell
                                    align="left" padding='none'
                                    className={classes.tableCell}
                                  >
                                    <FindInPageIcon
                                      onClick={event =>
                                        GetMaterialBulletin(
                                          event,
                                          row.MALZEME_STOK_NO
                                        )
                                      }
                                      color="primary"
                                    />
                                  </TableCell>
                                  <TableCell
                                    align="left" padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.ID === 0 ? (
                                      ''
                                    ) : (
                                      <DeleteForeverIcon
                                        onClick={event =>
                                          SetMaterialDelete(event, row, row.MALZEME_STOK_NO)
                                        }
                                        color="primary"
                                      />
                                    )}
                                  </TableCell>
                                  <TableCell
                                    align="left" padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.SIP_VERILEBILIR === 0 ?
                                      <LockIcon color="error" />
                                      :
                                      <AddShoppingCartIcon
                                        onClick={(event) => SepeteEkle(event, row.MALZEME_STOK_NO)}
                                        color="primary"
                                      />
                                    }
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>
      <Dialog
        open={bultenOpen}
        onClose={() => setBultenOpen(false)}
        TransitionComponent={Transition}
        keepMounted
      >
        <DialogTitle id="alert-dialog-title">
          Malzemeye Ait Bültenler
        </DialogTitle>
        <DialogContent>
          {LoadingMaterial ? (
            <LinearProgress status="loading" />
          ) : (
            <GenericBulten param={bultenParam} />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setBultenOpen(false)}
            className={classes.button}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openMaterialFile}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseMaterialFile}
      >
        <DialogTitle>{openMaterialFileTitle}</DialogTitle>
        <DialogContent>
          {LoadingMaterial ? (
            <LinearProgress status="loading" />
          ) : (
            <img style={{ width: '100%' }} alt="" src={ImageUrl} />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseMaterialFile} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openSiparisAdet}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseSiparisAdet}
      >
        <DialogTitle>{SiparisAdetTitle}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Typography id="input-slider" gutterBottom>
              Sipariş Adet
            </Typography>
            <Grid item xs={12} sm={12}>
              <Slider
                value={typeof siparisAdet === 'number' ? siparisAdet : 0}
                onChange={handleSliderChange}
                aria-labelledby="input-slider"
                max={999}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <Input
                className={classes.input}
                value={siparisAdet}
                margin="dense"
                fullWidth
                onChange={handleInputChange}
                onBlur={handleBlur}
                inputProps={{
                  step: 10,
                  min: 0,
                  max: 100,
                  type: 'number',
                  'aria-labelledby': 'input-slider'
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={SepeteEkleDetay} color="primary">
            Ekle
          </Button>
          <Button onClick={handleCloseSiparisAdet} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}

export default TechnicianPlan;
